import { DateTimeUtil } from '@/utils/DateTime'

export const DateTimeHelper = {
  ...DateTimeUtil
}
